import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";
import { Helmet } from "react-helmet-async";

/**
 * Reusable breadcrumb component with built-in schema.org BreadcrumbList markup.
 * Accepts `items`: [{ name, path }] — path is optional for the last item.
 */
export default function Breadcrumbs({ items = [] }) {
    if (!items.length) return null;

    const jsonLd = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: items.map((item, i) => ({
            "@type": "ListItem",
            position: i + 1,
            name: item.name,
            ...(item.path
                ? { item: `https://centroderehabilitaciondedrogas.cl${item.path}` }
                : {}),
        })),
    };

    return (
        <>
            <Helmet>
                <script type="application/ld+json">
                    {JSON.stringify(jsonLd)}
                </script>
            </Helmet>
            <nav
                aria-label="Breadcrumb"
                data-testid="breadcrumbs"
                className="text-xs text-slate-400"
            >
                <ol className="flex flex-wrap items-center gap-1">
                    {items.map((item, i) => {
                        const isLast = i === items.length - 1;
                        return (
                            <li key={i} className="flex items-center gap-1">
                                {i > 0 ? (
                                    <ChevronRight className="h-3 w-3 text-slate-600" />
                                ) : null}
                                {item.path && !isLast ? (
                                    <Link
                                        to={item.path}
                                        className="inline-flex items-center gap-1 rounded-md px-1.5 py-0.5 hover:bg-slate-900 hover:text-cyan-400"
                                    >
                                        {i === 0 ? <Home className="h-3 w-3" /> : null}
                                        {item.name}
                                    </Link>
                                ) : (
                                    <span
                                        aria-current={isLast ? "page" : undefined}
                                        className="inline-flex items-center gap-1 px-1.5 py-0.5 text-slate-300"
                                    >
                                        {i === 0 ? <Home className="h-3 w-3" /> : null}
                                        {item.name}
                                    </span>
                                )}
                            </li>
                        );
                    })}
                </ol>
            </nav>
        </>
    );
}
